<template>
  <span class="print-view bg-dark">
    <div class="btn-group float-right">
      <vs-button class="mt-2 mr-2" type="border" @click="onClickPrint">Print</vs-button>
    </div>


    <page id="printDiv" size="A4">
      <vx-card-custom style="border-radius: 0" :noShadow="true" :title="formulation.formulation_code">
        <vs-table :noDataText="''" class="table-dark-inverted">

          <template slot="thead">
            <vs-th></vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr>
              <vs-th>Formulation code</vs-th>
              <vs-td>{{ formulation.formulation_code }}</vs-td>
              <vs-th>Description</vs-th>
              <vs-td>{{ formulation.name }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-th>Legal name</vs-th>
              <vs-td>{{ formulation.legal_name }}</vs-td>
              <vs-th>Formulation type</vs-th>
              <vs-td>{{ formulation.formulation_type }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-th>Batch weight</vs-th>
              <vs-td>{{ formulation.batch_weight }}</vs-td>
              <vs-th>Status</vs-th>
              <vs-td>{{ formulation.status.name }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-th>QA Status</vs-th>
              <vs-td>{{ formulation.qa_status.name }}</vs-td>
              <vs-th>Manufacturing Instructions</vs-th>
              <vs-td>{{ formulation.manufacturing_instruction || 'N/A' }}</vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </vx-card-custom>
      <vx-card-custom style="border-radius: 0" :noShadow="true" title="Items">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-table id="formulation_table" :data="raw_material_items" :hoverFlat="true"
              class="table-dark-inverted w-full" noDataText="No raw materials available">

              <template slot="thead">
                <vs-th width="5%" class="__table-heading-small">MON</vs-th>
                <vs-th class="__table-heading-small">ITS PROD CODE</vs-th>
                <vs-th class="__table-heading-small">PROD NAME</vs-th>
                <vs-th class="__table-heading-small">QUANTITY (KG)</vs-th>
                <vs-th width="5%" class="__table-heading-small">%</vs-th>
                <vs-th width="5%" class="__table-heading-small">SOL</vs-th>
                <vs-th width="5%" class="__table-heading-small">HALAL</vs-th>
                <vs-th width="1%" class="__table-heading-small">KOSHER</vs-th>
                <vs-th class="__table-heading-small">RM COST IN USE (£/KG)</vs-th>
                <vs-th class="__table-heading-small">RM COST /KG</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr v-for="(tr, indextr) in data" :key="indextr">

                  <vs-td :data="data[indextr].manufacture_order" class="__table-heading-small">
                    {{ data[indextr].manufacture_order }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_product_code" class="__table-heading-small">

                    <span v-if="tr.formulation_code" class="" style="cursor: pointer">
                      {{ data[indextr].formulation_code }}
                    </span>
                    <vx-tooltip v-if="tr.company_product_code" position="left" text="View raw material">
                      <span class="" style="cursor: pointer">
                        {{ data[indextr].category + ' ' + data[indextr].company_product_code }}
                      </span>
                    </vx-tooltip>
                    <span v-if="tr.code" class="" style="cursor: pointer">
                      {{ data[indextr].code }}
                    </span>
                  </vs-td>

                  <vs-td class="__table-heading-small">
                    <span v-if="tr.company_product_name">{{ data[indextr].company_product_name }}</span>
                    <span v-if="tr.name">{{ data[indextr].name }}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].quantity" class="__table-heading-small">
                    {{ data[indextr].quantity }}
                  </vs-td>

                  <vs-td class="__table-heading-small">
                    {{ data[indextr].percentage }}
                  </vs-td>

                  <vs-td :data="data[indextr].dissolvable" class="__table-heading-small">
                    {{ data[indextr].dissolvable === 'Yes' ? 'S' : '' }}
                  </vs-td>

                  <vs-td :data="data[indextr].halal_suitable" class="__table-heading-small">
                    {{ suitableOrCertified(data[indextr].halal_suitable, data[indextr].halal_certified) }}
                  </vs-td>

                  <vs-td :data="data[indextr].kosher_suitable" class="__table-heading-small">
                    {{ suitableOrCertified(data[indextr].kosher_suitable, data[indextr].kosher_certified) }}
                  </vs-td>

                  <vs-td class="__table-heading-small">
                    {{ ((data[indextr].quantity * data[indextr].cost) / calTotalQuantity()).toFixed(2) }}
                  </vs-td>

                  <vs-td class="__table-heading-small">
                    {{ data[indextr].cost }}
                  </vs-td>

                </vs-tr>

                <vs-tr v-if="raw_material_items.length > 0">
                  <vs-td v-if="isIncludedDilCodedFormulation"></vs-td>
                  <vs-td colspan="2">
                    <b>Total</b>
                  </vs-td>
                  <vs-td>
                    {{ calTotalQuantity() }}
                  </vs-td>
                  <vs-td colspan="6">
                    <b>{{ calTotalPresentage() }} %</b>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card-custom>


    </page>
  </span>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
  name: "FormulationPrintView",
  data() {
    return {
      formulationId: '',
      raw_material_items: [],
      formulation: {},
      totalQty: '',
    }
  },
  mounted() {
    this.formulationId = this.$route.params.id
    this.loadFormulations()
    this.$emit('setAppClasses', 'print-view')
  },
  methods: {
    async loadFormulations() {
      await this.$vs.loading()
      try {
        const { data } = await FormulationsRepository.details(this.formulationId)
        this.formulation = data.data

        const spray_dry_carriers = data.data.spray_dry_carriers.map(carrier => {
          carrier.cost = Number(carrier.price)
          carrier.is_3rd_party_rm = true
          return carrier
        })


        if (this.formulation.formulation_items.length > 0) {
          this.raw_material_items = this.formulation.raw_material_items.concat(this.formulation.formulation_items)
        } else {
          this.raw_material_items = this.formulation.raw_material_items
        }
        if (this.formulation.formulation_type === 'spray dry powder' && spray_dry_carriers.length > 0) {
          this.raw_material_items = this.raw_material_items.concat(spray_dry_carriers)
        }

        this.raw_material_items = this.raw_material_items.map((x) => {
          x.cost = Number(x.cost)
          x.quantity = Number(x.quantity)
          return x
        })

        this.raw_material_items = this.raw_material_items.map((n) => {
          n.percentage = ((n.quantity / this.calTotalQuantity()) * 100).toFixed(3)
          return n
        })

        this.raw_material_items = this.raw_material_items.sort((a, b) => {
          if (a.manufacture_order < b.manufacture_order) return -1
          return a.manufacture_order > b.manufacture_order ? 1 : 0
        })
        this.totalQty = this.calTotalQuantity()
      } catch (e) {

      }
      this.$vs.loading.close()
    },
    calTotalQuantity() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity)
      })
      return total.toFixed(2)
    },
    calTotalPresentage() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.percentage)
      })
      return total.toFixed(3)
    },
    suitableOrCertified(suitable, certified) {
      let text = ''
      if (suitable === 'Yes') {
        text = text + ' S'
      }
      if (certified === 'Yes') {
        text = text + ' C'
      }
      return text
    },
    onClickPrint() {
      window.print()
    },
    onClickBack() {
      this.$router.push(`/pages/formulations/${this.formulationId}`)
    },
    calTotalValue() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity) * Number(m.cost)
      })
      return total.toFixed(2)
    },
  },
  computed: {
    isIncludedDilCodedFormulation() {
      return this.formulation.formulation_items.length > 0
    },
  },
}
</script>

<style lang="scss">
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

.__table-heading-small {
  font-size: 10px;
}
</style>
